// @flow

import type {Account} from './Account';

const ACCOUNT_LOADING = 'ACCOUNT_LOADING';
const ACCOUNT_LOADED = 'ACCOUNT_LOADED';

export type AccountLoadingEvent = {|
  type: typeof ACCOUNT_LOADING,
  payload: {},
|};

export const accountLoading = (): AccountLoadingEvent => ({
  type: ACCOUNT_LOADING,
  payload: {},
});

export type AccountLoadedEvent = {|
  type: typeof ACCOUNT_LOADED,
  payload: {account: Account},
|};

export const accountLoaded = (account: Account): AccountLoadedEvent => ({
  type: ACCOUNT_LOADED,
  payload: {account},
});

export type AccountEvent = AccountLoadingEvent | AccountLoadedEvent;

export type AccountEventDispatcher = (event: AccountEvent) => mixed;

export type AccountReducerState = {|
  account: Account,
  isLoading: boolean,
|};

export const AccountReducer = (
  state: AccountReducerState,
  event: AccountEvent,
) => {
  switch (event.type) {
    case ACCOUNT_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case ACCOUNT_LOADED:
      return {
        ...state,
        account: event.payload.account,
        isLoading: false,
      };
    default:
      throw new Error(`Unknown account action type ${event.type}`);
  }
};
